import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "top-menu" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/static/logo.png",
    class: "img-fluid"
  })
], -1)
const _hoisted_3 = { class: "navbar navbar-expand-lg navbar-light main-menu" }
const _hoisted_4 = { class: "navbar-nav m-auto" }
const _hoisted_5 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_6 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "top-menu-space" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Searchinput = _resolveComponent("Searchinput")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-print-none", _ctx.scrollClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.index,
              class: _normalizeClass(["nav-item", { active: _ctx.mainMenuActiveIndex === item.index }])
            }, [
              _createVNode(_component_RouterLink, {
                class: "nav-link",
                to: item.route
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ], 2))
          }), 128)),
          (!_ctx.isLogin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _createVNode(_component_RouterLink, {
                  class: "nav-link",
                  to: { path: '/user/login' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 登录/注册 ")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.isLogin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createVNode(_component_RouterLink, {
                  class: "nav-link",
                  to: { path: '/my/info' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 我的 ")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_Searchinput, {
              class: "nav-input",
              size: "",
              onEnterDoSearch: _ctx.handerlSearch,
              onSelectQuickSearch: _ctx.handerlSelect
            }, null, 8, ["onEnterDoSearch", "onSelectQuickSearch"])
          ])
        ])
      ])
    ]),
    _hoisted_8
  ], 2))
}